import { noop } from 'lodash'
import { createStore } from 'zustand'

import { toArray } from '@eastcoal/common/utils/array'

import { KindAllNodeStringOptions, KindAllNodeStringStore } from './interface'

export const createKindAllNodeStringStore = <M extends boolean>({
  valueKey = 'id'
}: KindAllNodeStringOptions<M>) =>
  createStore<KindAllNodeStringStore<M>>((set, get) => ({
    data: [],
    loading: false,
    error: undefined,
    reload: noop,

    multiple: undefined,
    value: undefined,
    valueKey,
    onChange: undefined,
    setValue(keys) {
      const { multiple, onChange } = get()
      const selectedKeys = multiple ? keys : toArray(keys)
      const value: any = selectedKeys
        ? multiple
          ? selectedKeys
          : selectedKeys[0]
        : undefined

      set({
        value
      })

      onChange?.(value)
    }
  }))
